export enum UserRole {
  SuperAdmin = 'SPA', // Deprecated
  Admin = 'ADM', // Deprecated
  SiteUser = 'SU', // Deprecated
  QualifiedPerson = 'QP', // Deprecated
  SourceSiteSuperAdmin = 'SSSADM',
  PATHManager = 'PM',
  SourceSiteAdmin = 'SSADM',
  SourceSiteUser = 'SSU',
  ReceivingSiteSuperAdmin = 'RSSADM',
  ReceivingSiteAdmin = 'RSADM',
  ReceivingSiteUser = 'RSU',
  QualifiedPersonSuperAdmin = 'QP',
  QualifiedPersonAdmin = 'QPSADM',
  QualifiedPersonSiteUser = 'QPSU'
}

export enum UserRoleName {
  SourceSiteSuperAdmin = 'Source Site Super Admin',
  ReceivingSiteSuperAdmin = 'Receiving Site Super Admin',
  PATHManager = 'PATH Manager'
}
